<template>
  <div class="page page-login">
    <div class="login-page-inner">
      <p class="title">IEDS设计师</p>
      <el-form
      @submit.native.prevent="() => {}"
        :model="formData"
        :rules="formRules"
        ref="loginForm"
        label-width="0px"
      >
        <el-form-item prop="username" v-show="currentOtherType < 1">
          <el-input
            v-model="formData.username"
            name="userName"
            placeholder="请输入手机号码"
            @keyup.enter.native="doLogin"
          >
            <i slot="prefix" class="iconfont icon-zhanghao"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="password" v-show="currentOtherType < 1">
          <div class="password-wrapper">
            <div class="password-input">
              <el-input
                v-model="formData.password"
                name="password"
                placeholder="请输入验证码"
                :type="inputType"
                @keyup.enter.native="doLogin"
              >
                <i slot="prefix" class="iconfont icon-mima"></i>
                <span
                  slot="suffix"
                  class="cursor-pointer"
                  @mousedown="mousedownPassword"
                >
                  <i class="iconfont icon-yincangmima"></i>
                </span>
              </el-input>
            </div>
            <div class="password-button">
              <el-button type="primary" plain @click="getCode">{{
                getCountdownTime
              }}</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item v-show="currentOtherType < 1">
          <div class="btn-hover" @click="doSubmit">登录</div>
        </el-form-item>
        <el-form-item v-show="currentOtherType == 1">
          <div class="wechat-login">
            <span style="color:#fff;">请使用微信扫小程序码登录</span>
            <img :src="wechatLoginQrcode" />
          </div>
        </el-form-item>
        <el-form-item>
          <div class="login-other" @click="changeOther">
            <img :src="other[currentOtherType].icon" />
            <span style="color:#fff;">{{ other[currentOtherType].text }}</span>
          </div>
        </el-form-item>
      </el-form>
      <el-checkbox v-model="privacyAgree"
        ><div style="color: #fff">
          我已阅读并同意<a
            href="https://ieds-user-test.idea888.com/service"
            target="_blank"
            style="color: #416bf4"
            >《服务协议》</a
          >和<a
            href="https://ieds-user-test.idea888.com/privacy"
            target="_blank"
            style="color: #416bf4"
            >《隐私协议》</a
          >
        </div></el-checkbox
      >
      <p class="login-page-bottom">
        Copyright © 2023 <span class="primary">三川田版权所有</span>
      </p>
    </div>
    <div class="login-background">
      <loginBackground />
    </div>
  </div>
</template>

<script>
import userModel from "@/libs/userModel";
import loginBackground from "@/components/login-background/index";
import { Form, FormItem, Input } from "element-ui";

export default {
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    loginBackground,
  },
  data() {
    return {
      loading: false,
      loadingVerify: false,
      inputType: "password",
      type: "login",
      privacyAgree: true,
      codeTextDefault: "获取验证码",
      codeText: "获取验证码",
      countdownTime: 60,
      formData: {
        email: "",
        username: "",
        password: "",
      },
      formRules: {
        username: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
      },
      currentOtherType: 0,
      other: [
        {
          icon: 'data:image/png;base64,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',
          text: '使用微信扫码登录',
        },
        {
          icon: 'data:image/png;base64,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',
          text: '使用手机号登录',
        }
      ],
      currentTimeMillis: new Date().getTime(),
      interval: '',
      wechatLoginQrcode: '',
    };
  },
  computed: {
    getCountdownTime() {
      return this.countdownTime < 60
        ? `倒计时${this.countdownTime}s`
        : this.codeText;
    },
  },
  created() {
    // 进入登录页面先清空个人信息
    this.fromUrl = this.$route.query.from
      ? window.decodeURIComponent(this.$route.query.from)
      : "";
    this.getWechatLoginQrcode();
  },
  methods: {
    async getWechatLoginQrcode(){
      const {code, data} = await this.$axios.get(`/sys/getQRCode?currentTimeMillis=${this.currentTimeMillis}`)
      if(code == 0){
        this.wechatLoginQrcode = data;
      }
    },
    async getWechatLogin(){
      if(this.currentOtherType == 1){
        const {code, data} = await this.$axios.get(`/sys/qrcodeInfo?currentTimeMillis=${this.currentTimeMillis}`)
        if(code == 0 && data && data.token){
          this.$store.commit('UPDATE_ACCESS_TOKEN', data.token)
          this.$store.commit('UPDATE_USER_INFO', {
            _id: data.userId,
            name: data.userName || data.mobile,
            username: data.userName || data.mobile,
            avatar: data.userHeadImage,
            mobile: data.mobile,
          })
          if (this.fromUrl) {
            this.$router.push(this.fromUrl);
          } else {
            userModel.goBeforeLoginUrl();
          }
        }
      }
    },
    changeOther(){
      if(this.currentOtherType == 0){
        this.currentOtherType = 1;
        this.interval = setInterval(this.getWechatLogin, 1000);
      }else{
        this.currentOtherType = 0;
        clearInterval(this.interval)
      }
    },
    countdown() {
      if (this.countdownTime > 0) {
        this.countdownTime--;
        setTimeout(() => {
          this.countdown();
        }, 1000);
      } else {
        this.countdownTime = 60;
        this.codeText = this.codeTextDefault;
      }
    },
    checkPrivacy() {
      if (!this.privacyAgree) {
        this.$store.dispatch("showMassage", {
          type: "error",
          message: "请阅读并同意《服务协议》和《隐私协议》",
        });
        return false;
      }
      return true;
    },
    async getCode() {
      if (!this.checkPrivacy()) return;
      if (!this.formData.username) {
        this.$store.dispatch("showMassage", {
          type: "error",
          message: "手机号码不能为空",
        });
        return;
      }
      const { code } = await this.$axios.get(
        `/sys/smsLoginOrRegisterCode/${this.formData.username}`
      );
      if (code == 0) {
        this.$message.success("验证码已发送");
        this.countdown();
      }
    },
    /**
			 登陆
			 */
    doSubmit() {
      // 验证成功
      this.$refs.loginForm.validate((valid) => {
        let fnName = this.type === "login" ? "doLogin" : "doRegister";
        if (valid) {
          this[fnName]();
        } else {
          this.$store.dispatch("showMassage", {
            type: "error",
            message: "请正确填写表单！",
          });
          return false;
        }
      });
    },
    doLogin() {
      if (!this.checkPrivacy()) return;
      let formData = {
        loginSide: "user",
        mobile: this.formData.username,
        verificationCode: this.formData.password,
      };
      // 登录操作
      userModel.doLogin(formData).then(() => {
        if (this.fromUrl) {
          this.$router.push(this.fromUrl);
        } else {
          userModel.goBeforeLoginUrl();
        }
      });
    },
    doRegister() {
      let formData = { ...this.formData };
      // 登录操作
      userModel.doRegister(formData).then(() => {
        if (this.fromUrl) {
          this.$router.push(this.fromUrl);
        } else {
          userModel.goBeforeLoginUrl();
        }
      });
    },
    switchType() {
      if (this.type === "login") {
        this.type = "register";
      } else {
        this.type = "login";
      }
    },
    mousedownPassword() {
      this.inputType = "text";
    },
    mousedownText() {
      this.inputType = "password";
    },
    mouseup() {
      this.inputType = "password";
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner{
  background: #1f2353;
  color: #fff;
}
.page-login {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fbfbfb;
}
.wechat-login {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img {
    width: 136px;
    height: 136px;
  }
}
.login-other {
  width: 100%;
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 36px;
  }
  span {
    color: #416bf4;
  }
}
.password-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.password-input {
  flex: 1;
  margin-right: 10px;
}
.password-button {
  flex-shrink: 0;
}

.login-background {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1;
}

.page-login {
  height: 100%;
  width: 100%;
  padding: 1px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 10;
}

.login-page-inner {
  position: relative;
  z-index: 10;
  width: 360px;
  padding: 20px 40px;
  margin-top: -120px;
  background: #1f2353b5;
  box-shadow: 0px 0px 0px rgba(58, 127, 158, 0.35);
  border-radius: 4px;
  box-shadow: 1px 1px 10px 10px rgba(120,127,160,0.56);
  .title {
    padding: 10px 0 30px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: $primary;
  }
  /**
    鼠标悬浮渐变
    */
  .btn-hover {
    margin-top: 12px;
    text-align: center;
    color: white;
    background: $color-gradient;
    transition: all 3s;
    border-radius: 4px;
    cursor: pointer;
  }
  .login-page-bottom {
    font-size: 12px;
    color: #fff;
    margin-top: 12px;
    text-align: center;
  }
  .forgot-password {
    text-align: right;
    font-size: 12px;
    margin-bottom: 20px;
    cursor: pointer;
    color: #333;
  }
}
.switch-do-type {
  font-size: 14px;
  text-underline: #000;
  text-align: right;
  color: #333;
  cursor: pointer;
  p {
    display: inline-block;
  }
  i {
    font-size: 16px;
    font-weight: 600;
  }
  &:hover {
    color: #000;
  }
}
</style>
